import React, {useContext} from 'react';
import {FaEye} from "react-icons/fa";
import RemoveButtonCellRenderer from "./cell-renderer/remove-button-cell-renderer";
import {ProjectContext} from "../context/project-context";

const AttachesButton = (params) => {
    const {user} = useContext(ProjectContext);
    const onlySeeAttendances = user.permissions.includes("see_attendances");
    const {api, node, openFile, readOnly} = params;

    return (
        <div className="flex flex-row justify-center h-full w-full">
            <span onClick={() => openFile(params, api, node)} className="w-[60px] h-full flex justify-center items-center text-gray-900 bg-gray-50 shadow border border-gray-300 cursor-pointer rounded-md me-[6px]">
                <FaEye/>
            </span>
            {
                !onlySeeAttendances && !readOnly &&
                <RemoveButtonCellRenderer api={api} node={node} modal={false}/>
            }
        </div>
    );
};

export default AttachesButton;
